import React from "react";
//#region types
import { TodoCardProps } from "models/propTypes/todoPropTypes";
//#endregion
//#region components
import AgingIncomingInvoiceFooter from "components/incomingInvoice/agingIncomingInvoiceFooter";
import OverPaidAgingIncomingInvoiceTodoFormContainer from "components/incomingInvoice/forms/overPaidAgingIncomingInvoiceTodoFormContainer";
import TopTodoCard from "components/todos/_partials/topTodoCard";
import {
  CommentsViewWithInputForm,
  EntityCardContent,
  GenericCommentsView,
  Profiles,
  TitledContainerInner,
} from "components/common";
import useAgingIncomingInvoiceTodoFormHelpers from "components/incomingInvoice/forms/useAgingIncomingInvoiceTodoFormHelpers";
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import cssExports from "theme/styles/main.module.scss";

const OverPaidAgingIncomingInvoiceTodo: React.FC<TodoCardProps> = (props) => {
  const todoType = props.item.subType;
  const agingInvoice = props.item.agingIncomingInvoiceTodoItem!;
  const { formRef, onViewInfoClick, submitInvoiceForm, fileViewerComponent, snoozeAction } =
    useAgingIncomingInvoiceTodoFormHelpers(agingInvoice, props.onActionSuccess);
  const dueDate = agingInvoice.dueDate ? DateHelper.formatDate(agingInvoice.dueDate) : "";

  return (
    <EntityCardContent
      topTodoCard={
        <TopTodoCard
          item={props.item}
          descriptionHeadingOne={LocalizationHelperInstance.getFormattedCurrency(
            agingInvoice?.amountWithSign ?? 0,
            agingInvoice?.currency
          )}
          descriptionHeadingTwo={
            <Profiles.SupplierProfileLink
              id={agingInvoice?.supplier?.id}
              name={agingInvoice?.supplier?.name ?? ""}
              className={cssExports.titleLink}
            />
          }
          descriptionheadingThree={`${LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Common.AmountPaid
          )}: ${LocalizationHelperInstance.getFormattedCurrency(
            agingInvoice?.amountPaid ?? 0,
            agingInvoice?.currency
          )}`}
          footerText={`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Due_Date)}: ${dueDate}`}
          onViewAllClick={onViewInfoClick}
          quickActions={[snoozeAction]}
        />
      }
      todoMainSection={
        <TitledContainerInner
          header={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.IncomingInvoice.AgingOverPaidHeader)}
          subHeader={
            !agingInvoice.isQuestion
              ? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.IncomingInvoice.AgingOverPaidDescripton)
              : ""
          }
        >
          {!agingInvoice.isQuestion ? (
            <OverPaidAgingIncomingInvoiceTodoFormContainer ref={formRef} invoice={agingInvoice} />
          ) : (
            <CommentsViewWithInputForm
              ref={formRef}
              parentId={agingInvoice.id}
              commentType={WintSuperkollAPIModel.GenericCommentType.AgingIncomingInvoice}
              commentOrFileRequired
              nonExpandable
            />
          )}
        </TitledContainerInner>
      }
      infoViewer={fileViewerComponent}
      footer={
        <AgingIncomingInvoiceFooter
          type={todoType}
          agingInvoice={agingInvoice!}
          invoiceFormSubmitHandler={submitInvoiceForm}
          markAsDoneHandler={props.onActionSuccess}
          disableSuccessMessages
        />
      }
    >
      {!agingInvoice.isQuestion ? (
        <GenericCommentsView
          parentId={agingInvoice!.id}
          type={WintSuperkollAPIModel.GenericCommentType.AgingIncomingInvoice}
          collapsed
        />
      ) : (
        <></>
      )}
    </EntityCardContent>
  );
};

export default OverPaidAgingIncomingInvoiceTodo;
